var _path;
import * as React from "react";
function SvgChampagneTulip(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M 10 2 C 8.4883687 7.641485 10.10868 13.398989 11.75 13.945312 L 11.75 22.113281 A 4 0.33162412 0 0 0 8 22.443359 A 4 0.33162412 0 0 0 12 22.775391 A 4 0.33162412 0 0 0 16 22.443359 A 4 0.33162412 0 0 0 12.25 22.113281 L 12.25 13.945312 C 13.89132 13.398989 15.511632 7.641485 14 2 L 10 2 z "
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChampagneTulip);
export default __webpack_public_path__ + "static/media/ChampagneTulip.840edeb486fe7b56bcd61c4f0815fece.svg";
export { ForwardRef as ReactComponent };